import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import image from "../../Assests/facilitiescart.png";
import moment from "moment";
import React from "react";
import { useState } from "react";
import emptyNotify from "../../Assests/emptyNotification.png";

const notifications = [
  // Today's notifications
  {
    id: "1",
    title: "Welcome to Our App!",
    body: "Thank you for joining us. Explore our features to get started.",
    url: "https://example.com/welcome",
    topic: "General",
    imageUrl: "https://example.com/images/welcome.png",
    createdTime: 1701201600000, // Example: Today, current timestamp
    isRead: false,
    seenStatus: false,
    day: "2024-11-28T12:00:00Z", // UTC date for reference
    type: "info",
    description: "4 new registrations for “Workshop: Working with designers and PMs”",
  },
  {
    id: "2",
    title: "New Feature Update",
    body: "Check out our latest feature to enhance your experience.",
    url: "https://example.com/feature",
    topic: "Updates",
    createdTime: 1701198000000, // Example: Today, 2 hours earlier
    isRead: true,
    seenStatus: true,
    day: "2024-11-28T11:00:00Z",
    type: "update",
    description: "4 new registrations for “Workshop: Working with designers and PMs”",
  },
  // Yesterday's notifications
  {
    id: "3",
    title: "Limited-Time Offer",
    body: "Get 20% off on all purchases for the next 24 hours.",
    url: "https://example.com/offer",
    topic: "Promotions",
    createdTime: 1701111600000, // Example: Yesterday, same time
    isRead: false,
    seenStatus: false,
    day: "2024-11-27T12:00:00Z",
    type: "promotion",
    description: "4 new registrations for “Workshop: Working with designers and PMs”",
  },
  // Previous 7 days notifications
  {
    id: "4",
    title: "System Maintenance Scheduled",
    body: "Our app will be down for maintenance on 2024-12-01 at 02:00 UTC.",
    url: "https://example.com/maintenance",
    topic: "Alerts",
    createdTime: 1700938800000, // Example: 5 days ago
    isRead: false,
    seenStatus: false,
    day: "2024-11-23T12:00:00Z",
    type: "alert",
    description: "4 new registrations for “Workshop: Working with designers and PMs”",
  },
  {
    id: "5",
    title: "Survey Request",
    body: "We'd love to hear your feedback. Complete our short survey.",
    url: "https://example.com/survey",
    topic: "Feedback",
    createdTime: 1700852400000, // Example: 6 days ago
    isRead: true,
    seenStatus: true,
    day: "2024-11-22T12:00:00Z",
    type: "request",
    description: "4 new registrations for “Workshop: Working with designers and PMs”",
  },
  // Previous 30 days notifications
  {
    id: "6",
    title: "Your Order Has Shipped",
    body: "Your order #12345 is on its way. Track your order now.",
    url: "https://example.com/order-tracking",
    topic: "Orders",
    imageUrl: "https://example.com/images/shipped.png",
    createdTime: 1699988400000, // Example: 15 days ago
    isRead: false,
    seenStatus: false,
    day: "2024-11-13T12:00:00Z",
    type: "notification",
    description: "4 new registrations for “Workshop: Working with designers and PMs”",
  },
  {
    id: "7",
    title: "Weekly Roundup",
    body: "Here are the top stories you missed this week.",
    url: "https://example.com/weekly-roundup",
    topic: "Newsletter",
    createdTime: 1699393200000, // Example: 22 days ago
    isRead: false,
    seenStatus: false,
    day: "2024-11-06T12:00:00Z",
    type: "newsletter",
    description: "4 new registrations for “Workshop: Working with designers and PMs”",
  },
  {
    id: "8",
    title: "Security Update Required",
    body: "Please update your password to maintain account security.",
    url: "https://example.com/security",
    topic: "Security",
    createdTime: 1698798000000, // Example: 28 days ago
    isRead: false,
    seenStatus: false,
    day: "2024-10-30T12:00:00Z",
    type: "security",
    description: "4 new registrations for “Workshop: Working with designers and PMs”",
  },
];

const Notifications: React.FunctionComponent = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const notificationButtons = ["All", "Unread", "Read"];

  const [isActiveMsg, setIsActiveMsg] = useState<string>("All");

  const handleMessageCategory = (text: string) => {
    setIsActiveMsg(text);
  };

  const formatNotification = () => {
    let newDataSet: any = {};

    const checkHasProperty = (key: string, data: any) => {
      if (newDataSet.hasOwnProperty(key)) {
        newDataSet[key].push(data);
      } else {
        newDataSet[key] = [data];
      }
    };

    for (let i = 0; i < notifications.length; i++) {
      const element = notifications[i];
      const notificationTime = moment(element.createdTime).set({ year: 2024 });
      const currentTime = moment();

      if (notificationTime.isSame(currentTime, "day")) {
        checkHasProperty("today", element);
      } else if (notificationTime.isSame(currentTime.subtract(1, "day"), "day")) {
        checkHasProperty("yesterday", element);
      } else if (notificationTime.isAfter(currentTime.subtract(7, "days"), "day") && notificationTime.isSameOrBefore(currentTime.subtract(1, "day"), "day")) {
        checkHasProperty("previous 7 days", element);
      } else if (notificationTime.isAfter(currentTime.subtract(30, "days"), "day") && notificationTime.isSameOrBefore(currentTime.subtract(7, "days"), "day")) {
        checkHasProperty("previous 30 days", element);
      } else {
        checkHasProperty("past", element);
      }
    }

    return newDataSet;
  };

  formatNotification();

  return (
    <Box component={"div"} padding={isMobileScreen ? "20px" : "16px"} height={"100%"} bgcolor={"#fff"}>
      <Box component={"div"} className="d-flex justify-content-between">
        {!isMobileScreen && (
          <Typography component={"h6"} sx={{ cursor: "pointer" }} variant="largemedium" color={"#373A45"} margin={"10px 0px"}>
            Notification
          </Typography>
        )}
        <Typography component={"h6"} sx={{ cursor: "pointer" }} variant="smallmedium" color={"#6A4EA6"} margin={"10px 0px"}>
          Mark all as read
        </Typography>
      </Box>
      <Box component={"div"} className="d-flex align-items-center gap-1" marginTop={"10px"}>
        {notificationButtons.map((items, index) => {
          const isActive = items === isActiveMsg;
          return (
            <Typography
              component={"h6"}
              onClick={() => {
                handleMessageCategory(items);
              }}
              sx={{
                padding: "8px",
                textAlign: "center",
                background: isActive ? "#604797" : "#F0EDF6",
              }}
              className="w-100"
              key={index}
              variant={!isActive ? "smallthin" : "smallmedium"}
              color={!isActive ? "#604797" : "#FFFFFF"}
            >
              {items}
            </Typography>
          );
        })}
      </Box>
      {formatNotification().length === 0 ? (
        <Box component={"div"} className="d-flex flex-column align-items-center justify-content-center" gap={"20px"} height={"70%"}>
          <Box component={"img"} src={emptyNotify} height={"180px"} width={"100%"} sx={{ objectFit: "contain" }} />
          <Typography variant="mediumthin" color={"#333333"}>
            You're all caught up! No new notifications at the moment.
          </Typography>
        </Box>
      ) : (
        <>
          {Object.keys(formatNotification()).map((items) => {
            const data = formatNotification();

            return (
              <Box key={items} component={"div"} className="d-flex flex-column" marginTop={"14px"}>
                {!isMobileScreen && (
                  <Typography variant="extrasmallthin" sx={{ textTransform: "capitalize", textAlign: "center" }} color={"#8A8A8A"}>
                    {items}
                  </Typography>
                )}
                <Box component={"div"} className="d-flex flex-column" gap={"4px"}>
                  {(data[items] || [])
                    .filter((msgs: any) => {
                      if (isActiveMsg === "Unread") {
                        return msgs.isRead === false;
                      } else if (isActiveMsg === "Read") {
                        return msgs.isRead === true;
                      } else {
                        return msgs;
                      }
                    })
                    .sort((a: any, b: any) => {
                      return a.createdTime - b.createdTime;
                    })
                    .map((item: any, index: number) => {
                      return (
                        <Box component={"div"} className="d-flex align-items-center" gap={"12px"} borderBottom={data[items]?.length === index + 1 ? "0.5px solid transparent" : "0.5px solid #E6E6E6"} padding={"12px"}>
                          <Box component={"img"} src={image} height={"56px"} width={"56px"} borderRadius={"50px"} />
                          <Box component={"div"} className="d-flex flex-column" gap={"6px"}>
                            <Typography variant="medium" component={"h6"} color={"#6A4EA6"}>
                              {item?.title}
                            </Typography>
                            <Typography variant="extrasmallthin" component={"h6"} color={"#333333"}>
                              {item?.description}
                            </Typography>
                          </Box>
                        </Box>
                      );
                    })}
                </Box>
              </Box>
            );
          })}
        </>
      )}
      {}
    </Box>
  );
};

export default Notifications;
